<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box" >
			<div class="modal modal-lg p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						보낸 전자우편
						<small class="text-nomal m-l-10">보내는 사람 : 이윤미 ymlee@korea.co.kr</small>
					</h2>
					<a href="#none" class="close" @click="$emit('close')">&times;</a>
					<div class="config">
						<button class="btn-sm round">안내</button>
					</div>
				</div>
				<div class="modal-body p-10 clearfix">
					<div class="send-box left">
						<h3 class="send-tit"><span>받는사람</span></h3>
						<ul class="item-list">
							<li>
								<span class="name">홍길동</span><span class="info">gogoHome@naver.com</span>
								<a class="minus" href="#none"></a>
							</li>
						</ul>
						<p class="m-b-0">
							<span>전송성공:48건</span>
							|
							<span>전송실패: 8건</span>
						</p>
					</div>
					<div class="send-box right">
						<h3 class="send-tit"><span>보낸 전자우편함</span></h3>
						<div class="send-box full-width">
							<input type="text" class="form-control full-width m-b-10 round text-left"
								value="[찾아가는 국어문화학교] 강의확인서(강사용) 작성 요청드립니다." disabled>
							<div class="input-group on-border round full-width m-b-10">
								<span class="input-group-addon v-mid w40">
									<a href="#none">
										<svg xmlns="http://www.w3.org/2000/svg" class="v-mid" width="22" height="18" viewBox="0 0 53 49">
											<path class="down-on"
												d="M56.482,23.889A1.51,1.51,0,0,0,54.963,25.4V39.182a6.806,6.806,0,0,1-6.8,6.788H14.842a6.806,6.806,0,0,1-6.8-6.788v-14a1.518,1.518,0,0,0-3.037,0v14A9.841,9.841,0,0,0,14.842,49H48.158A9.841,9.841,0,0,0,58,39.182V25.4A1.517,1.517,0,0,0,56.482,23.889ZM30.432,36.972a1.53,1.53,0,0,0,1.069.449,1.484,1.484,0,0,0,1.069-.449l9.651-9.627A1.517,1.517,0,0,0,40.071,25.2l-7.053,7.046V1.515a1.518,1.518,0,0,0-3.037,0V32.248L22.918,25.2a1.517,1.517,0,1,0-2.148,2.143Z"
												transform="translate(-5)" />
										</svg>
									</a>
								</span>
								<span class="input-group-addon text-left">
									강의확인서(신청자용).hwp
								</span>
							</div>
						</div>

						<div class="text-edit on-border round p-15">
							찾아가는 국어문화학교 사업이 신청만 홈페이지(온라인)을 통해서 받고 나머지 모든 과정<br>
							<br>
							1. 강사섭외(국어원->지역문화원)<br>
							2. 강사섭외 결과회신(지역문화원->국어원)<br>
							3. 강의확정통보(국어원->지역문화원)<br>
							4. 강의신청결과 통보(국어원->신청 기관)<br>
							5. 강의확인서회신(배정강사->국어원)<br>
							6. 설문지회신(신청 기관담당자->국어원)<br>
							<br>
							이후는 제가 수기로 결과 및 통계를 엑셀파일에 입력(정리)하고 있습니다.<br>
							제가 다 수기로 정리하고 있기에 홈페이지 개편에 대한 구체적인 아이디어가 많이 없는 상황이에요 ^^;
						</div>
						<p class="m-b-0">
							<span>보낸일시: 2019년 6월 20일 14:20:10</span>
						</p>
					</div>
				</div>
				<div class="modal-footer p-15 clearfix">
					<button class="btn full-width bg-deepblue text-white round m-r-5" type="button">확인</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name:"ModalSentEmail",

	default: function() {
		return {
			name: this.name,
			show: false
		}
	},

	props:{
		config: Object
	}
}
</script>

<style scoped>
.down-on {
	fill: #999;
	fill-rule: evenodd;
}
a:hover .down-on {
	fill: #156ea2;
	fill-rule: evenodd;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>